<template>
  <b-modal
    :id="id"
    size="lg"
    :title="lehrgangId ? $t('global.cancelcourse') : $t('global.cancelevent')"
    no-close-on-backdrop
    @show="beimOeffnen"
    @hidden="beimSchliessen"
  >
    <div v-if="mitOptionen && !lehrgangId" class="mb-3">
      <div class="mb-1">
        {{ $t("global.selectwhicheventsshouldbecancelled") }}
        <font-awesome-icon
          v-tooltip.hover
          :title="$t('global.eventcancellationtooltip')"
          icon="fa-solid fa-circle-info"
        />
      </div>
      <div v-for="o in optionen" :key="o.value">
        <label>
          <input type="radio" :value="o.value" v-model="option" @change="ladeVorschau" />
          {{ o.text }}
        </label>
      </div>
    </div>

    <div v-if="vorschau">
      <div class="mb-2"><b>{{ $t("global.cancellationsummary") }}</b></div>
      <ul>
        <li>
          {{ vorschau.veranstaltungen.length }} {{ $t("global.eventswillbecancelled") }}
          <span v-if="vorschau.veranstaltungen.length <= 5" class="text-muted">
            ({{ vorschau.veranstaltungen.map((v) => v.bezeichnung).join(", ") }})
          </span>
        </li>
        <li>{{ vorschau.anzahlAnmeldungen }} {{ $t("global.registrationswillbederegistered") }}</li>
        <li>{{ vorschau.anzahlTermine }} {{ $t("global.appointmentswillbecancelled") }}</li>
        <li v-if="vorschau.anzahlZimmerreservationen > 0" class="text-danger">
          {{ vorschau.anzahlZimmerreservationen }} {{ $t("global.roomreservationswillberemoved") }}
        </li>
      </ul>

      <b-form-checkbox v-model="dozenteneinsaetzeEntfernen" :disabled="vorschau.dozenteneinsaetzeZukuenftig == 0">
        {{ $t("global.removefuturelecturerassignments") }} ({{ vorschau.dozenteneinsaetzeZukuenftig }})
      </b-form-checkbox>
      <div v-if="vorschau.dozenteneinsaetzeVergangen > 0" class="text-muted small ml-4">
        {{ vorschau.dozenteneinsaetzeVergangen }} {{ $t("global.pastlecturerassignmentsremain") }}
      </div>

      <div v-if="lehrgangId && vorschau.lehrgangstatusAbgesagt === false" class="alert alert-warning mt-3 mb-0">
        {{ $t("global.nocoursestatuscancelled") }}
      </div>
    </div>
    <div v-else-if="laedt" class="text-muted">{{ $t("global.loadmoredata") }}</div>

    <template #modal-footer>
      <button class="btn btn-default" @click="abbrechen">{{ $t("global.cancel") }}</button>
      <button class="btn btn-danger" :disabled="!vorschau || laedt || (mitOptionen && !lehrgangId && !option)" @click="absagen">
        {{ lehrgangId ? $t("global.cancelcourse") : $t("global.cancelevent") }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import AppApi from "@/api/AppApi";
import { apiErrorToAlert } from "@/utils/Errorhandler";

/**
 * Absage einer Veranstaltung (Kurzveranstaltung, Klasse, Fach) oder eines ganzen Lehrgangs mit Vorschau:
 * Anmeldungen, Termine, Zimmerreservationen und – optional – zukünftige Dozenteneinsätze.
 * Events: abgesagt (Ergebnis), abgebrochen (Modal ohne Absage geschlossen).
 */
export default {
  name: "VeranstaltungAbsageModal",
  props: {
    id: { type: String, default: "veranstaltung-absage-modal" },
    veranstaltungId: { type: String, default: null },
    lehrgangId: { type: String, default: null },
    // Klasse/Fach: nur diese / mit Fächern / ganzer Lehrgang
    mitOptionen: { type: Boolean, default: false },
  },
  data() {
    return {
      option: "currentEvent",
      vorschau: null,
      laedt: false,
      dozenteneinsaetzeEntfernen: true,
      abgesagt: false,
    };
  },
  computed: {
    optionen() {
      return [
        { value: "currentEvent", text: this.$t("global.onlytheseevents") },
        { value: "currentAndSubevents", text: this.$t("global.theseeventsandsubevents") },
        { value: "allEvents", text: this.$t("global.alleventsfromsamecourse") },
      ];
    },
    params() {
      return this.lehrgangId
        ? { lehrgang: this.lehrgangId }
        : { veranstaltung: this.veranstaltungId, option: this.option };
    },
  },
  methods: {
    beimOeffnen() {
      this.option = "currentEvent";
      this.dozenteneinsaetzeEntfernen = true;
      this.abgesagt = false;
      this.ladeVorschau();
    },
    beimSchliessen() {
      if (!this.abgesagt) this.$emit("abgebrochen");
    },
    ladeVorschau() {
      this.laedt = true;
      this.vorschau = null;
      AppApi.get("veranstaltung-absage/", { params: this.params })
        .then((response) => (this.vorschau = response.data))
        .catch((e) => this.$notify(apiErrorToAlert(e)))
        .finally(() => (this.laedt = false));
    },
    abbrechen() {
      this.$bvModal.hide(this.id);
    },
    absagen() {
      this.laedt = true;
      AppApi.put("veranstaltung-absage/", {}, {
        params: { ...this.params, dozenteneinsaetze: this.dozenteneinsaetzeEntfernen ? "true" : "false" },
      })
        .then((response) => {
          this.abgesagt = true;
          this.$notify({
            type: "success",
            title: this.$t("global.actionsuccessful"),
            text: this.$t("global.cancellationsuccessful"),
          });
          this.$emit("abgesagt", response.data);
          this.$bvModal.hide(this.id);
        })
        .catch((e) => this.$notify(apiErrorToAlert(e)))
        .finally(() => (this.laedt = false));
    },
  },
};
</script>
